import { removeUndefinedAndNullProperties } from 'lib/object/objectUtils'
import { isEmptyObject } from 'lib/object/isEmptyObject'

function sanitizeItemContextMetadata(props: any): string | undefined {
  const metadata = removeUndefinedAndNullProperties(props)
  if (!isEmptyObject(metadata)) {
    return JSON.stringify(metadata)
  }
}
export default sanitizeItemContextMetadata
